/* eslint-disable */
import React, { useEffect, useRef } from 'react';
import { useLanguage } from '../context/LanguageContext';
import { logVisit } from '../services/api';

const CONSENT_COOKIE = 'silamezs_cookie_consent';
const SESSION_COOKIE = 'silamezs_session_id';

const readCookie = (name) => {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts.length === 2) return parts.pop().split(';').shift();
  return null;
};

const CookieConsent = () => {
  const { t } = useLanguage();
  const hasLoggedRef = useRef(false);
  const hasConsent = readCookie(CONSENT_COOKIE) === 'accepted';

  const writeCookie = (name, value, days = 365) => {
    const maxAge = days * 24 * 60 * 60;
    document.cookie = `${name}=${value}; max-age=${maxAge}; path=/; SameSite=Lax`;
  };

  useEffect(() => {
    if (!hasConsent) return;
    logExistingVisit();
  }, [hasConsent]);

  const logExistingVisit = async () => {
    if (hasLoggedRef.current) return;
    hasLoggedRef.current = true;
    let sessionId = readCookie(SESSION_COOKIE);
    if (!sessionId) {
      sessionId = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
      writeCookie(SESSION_COOKIE, sessionId, 365);
    }

    try {
      await logVisit({
        session_id: sessionId,
        page_path: window.location.pathname
      });
    } catch (error) {
      console.error('Visit logging failed:', error);
    }
  };

  const handleAccept = async () => {
    writeCookie(CONSENT_COOKIE, 'accepted', 365);
    await logExistingVisit();
    window.location.reload();
  };

  if (hasConsent) return null;

  return (
    <div className="fixed inset-x-0 bottom-4 z-[60] px-4" data-testid="cookie-consent-banner">
      <div className="max-w-4xl mx-auto bg-white border border-[#1F3D2B]/15 shadow-lg rounded-2xl p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <div className="text-sm text-[#2E2E2E]/70" data-testid="cookie-consent-text">
          {t('cookie.text', 'Šī vietne izmanto sīkdatnes, lai uzlabotu lietošanas pieredzi.')}
        </div>
        <button
          onClick={handleAccept}
          className="ml-auto px-5 py-2 rounded-xl bg-[#1F3D2B] text-white text-sm font-semibold hover:bg-[#163021] transition-colors"
          data-testid="cookie-consent-accept"
        >
          {t('cookie.accept', 'Piekrītu')}
        </button>
      </div>
    </div>
  );
};

export default CookieConsent;
